import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getMenus: action({
    type: 'layout.getMenus',
    action: (http) => {
      return http.get('/cms-web-api/cms/cat/list/ztx')
    },
    handler: (state, result) => {
      const menus = result.data
      let parentMenus
      if (menus) {
        menus.forEach((menu) => {
          if (menu.pid > 0) {
            menus.forEach((m) => {
              if (m.id === menu.pid) {
                m.children ? m.children.push(menu) : m.children = [menu]
              }
            })
          }
        })

        parentMenus = menus.filter((menu) => {
          return menu.pid === 0
        })
      }
      return {
        ...state,
        menus: parentMenus
      }
    }
  }, reducerHandler),

  getHomeConfigs: action({
    type: 'home.getHomeConfigs',
    action: (http, dispatch, getState) => {
      return http.get('/cms-web-api/config/mutil',{
        params: {
          names:[
            'productAdPanel',//产品广告位置
            'banner',//首页轮播图
            'homeNews',//首页新闻中心带图片新闻
            'friendshipLink'//首页新闻中心带图片新闻
          ]
        }
      })//获得广告位信息
    },
    handler: (state, result) => {
      return {
        ...state,
        productAdPanel: result && result.data.productAdPanel,//产品广告位置
        banner:result && result.data.banner,//轮播图
        homeNews:result && result.data.homeNews,//首页新闻中心带图片新闻
        friendshipLink:result && result.data.friendshipLink,//友情链接
      }}
  }, reducerHandler)

}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  menus: []
}


export function layoutReducer (state = initialState, action) {

  if (!action) {
    return state
  }

  const handler = ACTION_HANDLERS[action.type]
  let nextState =  handler ? handler(state, action) : {...state}
  nextState = reducerHandler(initialState)(nextState, action)
  return nextState
}



// WEBPACK FOOTER //
// ./components/layout/layoutModule.js